import { currentLocale } from '@web/i18n';

/**
 * Formats a `Date` or ISO string as `HH:MM` in the UI locale (always a 24h
 * clock — `en` would otherwise render "11:30 PM"), returning `''` when the
 * input is missing or unparseable so callers never render `"Invalid Date"`.
 *
 * `timeZone` is an IANA zone to render the instant in (an airport's, say);
 * omitted, the browser's own zone applies. Check a server-supplied zone with
 * `isSupportedTimeZone` first — an unknown name makes `Intl` throw.
 */
export function formatHhMm(input: Date | string, options: { timeZone?: string } = {}): string {
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString(currentLocale(), {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: options.timeZone,
  });
}
